/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

import BankreconciliationImport from 'vcomponents/bankreconciliation/BankreconciliationImport.vue';
import ReconciliationStep1 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep1.vue';
import ReconciliationStep2 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep2.vue';
import ReconciliationStep3 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep3.vue';
import ReconciliationStep31 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep3-1.vue';
import ReconciliationStep32 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep3-2.vue';
import ReconciliationStep4 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep4.vue';
import ReconciliationStep5 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep5.vue';
import ReconciliationStep6 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep6.vue';
import ReconciliationStep7 from 'vcomponents/bankreconciliation/importsteps/ReconciliationStep7.vue';

export default [
    {
        path: '/bankreconciliation/import',
        name: 'bankreconciliation-import',
        component: BankreconciliationImport,
        props: true,
        children: [
            {
                path: 'step1',
                name: 'bankreconciliation-step1',
                component: ReconciliationStep1,
                props: true,
                meta: {
                    next: 'bankreconciliation-step2'
                }
            },
            {
                path: 'step2/:importid',
                name: 'bankreconciliation-step2',
                component: ReconciliationStep2,
                props: true,
                meta: {
                    previous: 'bankreconciliation-step1',
                    next: 'bankreconciliation-step3'
                }
            },
            {
                path: 'step3/:importid',
                name: 'bankreconciliation-step3',
                component: ReconciliationStep3,
                props: true,
                meta: {
                    previous: 'bankreconciliation-step2',
                    next: 'bankreconciliation-step4'
                }
            },
            {
                path: 'step3-1/:importid',
                name: 'bankreconciliation-step3-1',
                component: ReconciliationStep31,
                props: true,
                meta: {
                    previous: 'bankreconciliation-step3',
                    next: 'bankreconciliation-step4'
                }
            },
            {
                path: 'step3-2/:importid',
                name: 'bankreconciliation-step3-2',
                component: ReconciliationStep32,
                props: true,
                meta: {
                    previous: 'bankreconciliation-step3',
                    next: 'bankreconciliation-step4'
                }
            },
            {
                path: 'step4/:importid',
                name: 'bankreconciliation-step4',
                component: ReconciliationStep4,
                props: true,
                meta: {
                    previous: 'bankreconciliation-step3',
                    next: 'bankreconciliation-step5'
                }
            },
            {
                path: 'step5/:importid',
                name: 'bankreconciliation-step5',
                component: ReconciliationStep5,
                props: true,
                meta: {
                    previous: 'bankreconciliation-step4',
                    next: 'bankreconciliation-step6'
                }
            },
            {
                path: 'step6/:importid',
                name: 'bankreconciliation-step6',
                component: ReconciliationStep6,
                props: true,
                meta: {
                    previous: 'bankreconciliation-step5',
                    next: 'bankreconciliation-step7'
                }
            },
            {
                path: 'step7/:importid',
                name: 'bankreconciliation-step7',
                component: ReconciliationStep7,
                props: true,
                meta: {
                    previous: 'bankreconciliation-step5',
                }
            },
        ]
    }
]
